module.exports = __webpack_public_path__ + "img/apps.523ca0a7.png";